import { render, staticRenderFns } from "./UseTermsFilter.vue?vue&type=template&id=5d07632b&scoped=true"
import script from "./UseTermsFilter.vue?vue&type=script&lang=js"
export * from "./UseTermsFilter.vue?vue&type=script&lang=js"
import style0 from "./UseTermsFilter.vue?vue&type=style&index=0&id=5d07632b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d07632b",
  null
  
)

export default component.exports